import React from "react";
import Moment from "moment";
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setStep, setInfo, setFinance, setLatest, setCurrent } from "../../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../partials/AlertDialogSlide";
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextFinanceButton from "../../partials/NextFinanceButton";

import AccountLayout from '../../../containers/AccountLayout';

/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();

/*
    PayFrequency view that displays the Pay Frequency page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class PayFrequency extends React.Component {

  constructor(){
    super();

    this.frequencychecked = false;
    this.detailschecked = false;

    this.weeklychecked = false;
    this.biweeklychecked = false;
    this.monthlychecked = false;
    this.semimonthlychecked = false;

    this.weekdaychecked = false;

    this.paydatechecked = false;
    this.payamountchecked = false;

    this.paydaychecked = false;
    this.monthweekchecked = true;
    this.monthweekdaychecked = true;

    this.payday1checked = false;
    this.payday2checked = false;

    this.showamount = true;

    this.lastpaydate = '';
    this.nextpaydate = '';
    this.prevpaydate = '';
    this.nextpaydate2 = '';
    this.nextpaydate1 = '';

    this.nextpay1 = '';
    this.nextpay2 = '';
    this.lastpay1 = '';
    this.lastpay2 = '';

    this.prevpayday = '';
    this.lastpayday = '';
    this.nextpayday = '';

    this.semifirstpick = '';

    this.weekday = 0;
    this.lastpayid = "";

    this.payweek = '';
    this.payweekday = '';

    this.handleFrequencyChange = this.handleFrequencyChange.bind(this);

    this.handleWeekdayChange = this.handleWeekdayChange.bind(this);
    this.handleLastPayChange = this.handleLastPayChange.bind(this);

    this.handleMonthPopChange = this.handleMonthPopChange.bind(this);
    this.handleMonthChoiceChange = this.handleMonthChoiceChange.bind(this);
    this.handleMonthOtherChange = this.handleMonthOtherChange.bind(this);
    this.handleMonthWeekChange = this.handleMonthWeekChange.bind(this);
    this.handleMonthWeekdayChange = this.handleMonthWeekdayChange.bind(this);
    this.handleMonthChange = this.handleMonthChange.bind(this);

    this.handleSemiPopChange = this.handleSemiPopChange.bind(this);
    this.handleSemiOtherChange = this.handleSemiOtherChange.bind(this);
    this.handleSemiChange = this.handleSemiChange.bind(this);

    this.getLastWeekOfMonth = this.getLastWeekOfMonth.bind(this);
    this.weekendCheck = this.weekendCheck.bind(this);
    this.chooseWeekDay = this.chooseWeekDay.bind(this);
    this.calcMonthPaydates = this.calcMonthPaydates.bind(this);

    this.handlePayAmountChange = this.handlePayAmountChange.bind(this);

    this.today = new Date();
    this.today.setHours(0, 0, 0, 0);
    this.payyear = this.today.getFullYear();
    this.theday = this.today.getDate();
    this.themonth = this.today.getMonth();
    this.paymonth = parseInt(this.themonth, 10) + 1;
    if (this.paymonth < 10){
      this.paymonth = "0" + this.paymonth;
    }
    this.lastmonth = this.themonth;
    if (this.lastmonth < 1){
      this.lastmonth = 12;
    }
    this.nextmonth = this.themonth + 2;
    if (this.nextmonth > 12){
      this.nextmonth = 1;
    }
    this.state = {
      maxdate: this.today,
      mindate: this.today
    };
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Payment Schedule");
    this.props.lateststep < 6 && this.props.setLatest(6);
    this.props.setCurrent(6);
    this.props.setStep(1);
    this.props.setInfo(3);
    this.props.setFinance(1);

    if (this.props.payfrequency && this.props.payfrequency.length > 0){
      this.frequencychecked = true;

      let querydataanswer = "#payfrequencybuttons [data-answer='"+this.props.payfrequency+"']";
      document.querySelectorAll(querydataanswer)[0].classList.add('picked');

      const weeklydetails = document.getElementById("weekdays");
      const biweeklydetails = document.getElementById('biweeklydetails');
      const monthlydetails = document.getElementById("monthlydetails");
      const semimonthlydetails = document.getElementById("semimonthlydetails");
      const amountdetails = document.getElementById("amountdetails");

      // What happens with weekend pay dates is based upon paymenttype so need to check if that got changed
      if (this.props.paytypefilled && this.props.paytypeold !== this.props.paymenttype){
        if (this.props.payfrequency === "Semi-Monthly" || this.props.payfrequency === "Monthly"){
          if (this.props.payfrequency === "Monthly" && this.props.payday > 0){
            this.calcMonthPaydates(this.props.payday);
            this.lastpayday = this.weekendCheck(this.lastpayday);
            this.nextpayday = this.weekendCheck(this.nextpayday);
            this.props.updateForm("lastpay", this.lastpayday);
            this.props.updateForm("nextpay", this.nextpayday);
          } else if (this.props.payfrequency === "Semi-Monthly" && this.props.payday > 0 && this.props.payday2 > 0){
            this.calcMonthPaydates(this.props.payday, this.props.payday2);
            this.lastpayday = this.weekendCheck(this.lastpayday);
            this.nextpayday = this.weekendCheck(this.nextpayday);
            this.props.updateForm("lastpay", this.lastpayday);
            this.props.updateForm("nextpay", this.nextpayday);
          }
        }
      }

      if (this.props.payfrequency === "Bi-weekly" || this.props.payfrequency === "Weekly"){
        weeklydetails.classList.remove("hidden");
        if (this.props.weekday.length > 0){
          querydataanswer = "#weekdays [data-answer='"+this.props.weekday+"']";
          document.querySelectorAll(querydataanswer)[0].classList.add('picked');
        }
        if (this.props.payfrequency === "Bi-weekly"){
          this.biweeklychecked = true;
          if (this.props.weekday.length > 0){
            biweeklydetails.classList.remove("hidden");
            if (this.props.prevpaydate.length > 0){
              this.prevpaydate = this.props.prevpaydate;
              this.lastpaydate = this.props.lastpaydate;
              this.nextpaydate1 = this.props.nextpaydate1;
              this.nextpaydate2 = this.props.nextpaydate2;

              this.lastpay1 = Moment(this.prevpaydate+", "+this.payyear).format("MM/DD/YYYY");
              this.nextpay1 = Moment(this.nextpaydate1+", "+this.payyear).format("MM/DD/YYYY");
              this.lastpay2 = Moment(this.lastpaydate+", "+this.payyear).format("MM/DD/YYYY");
              this.nextpay2 = Moment(this.nextpaydate2+", "+this.payyear).format("MM/DD/YYYY");
            }
            if (this.props.lastpay.length > 0){
              let pickeddate = Moment(this.props.lastpay).format("MMM D");
              querydataanswer = "[data-full='"+pickeddate+"']";
              document.querySelectorAll(querydataanswer)[0].classList.add('picked');
              if (this.props.nextpay.length > 0){
                this.paydatechecked = true;
                this.nextpaydate = Moment(this.props.nextpay).format("MMM D");
                amountdetails.classList.remove("hidden");
                if (this.props.payamount.length > 0){
                  this.payamountchecked = true;
                  this.detailschecked = true;
                  document.querySelector("label[for='amt']").classList.add("activeamt");
                }
              }
            }
          }
        } else {
          this.weeklychecked = true;
          if (this.props.lastpay.length > 0 && this.props.nextpay.length > 0){
            amountdetails.classList.remove("hidden");
            if (this.props.payamount.length > 0){
              this.payamountchecked = true;
              this.detailschecked = true;
              document.querySelector("label[for='amt']").classList.add("activeamt");
            }
          }
        }
      } else if (this.props.payfrequency === "Monthly"){
        monthlydetails.classList.remove("hidden");
        this.monthlychecked = true;

        if (this.props.otherpay.length > 0){
          document.getElementById("popmonthlyother").classList.add("picked");
          document.getElementById("othermonth").classList.remove("hidden");
          if (this.props.otherpay === "Specific Date" || this.props.otherpay === "Day of the Week"){
            querydataanswer = "[data-answer='"+this.props.otherpay+"']";
            document.querySelectorAll(querydataanswer)[0].classList.add('picked');
            if (this.props.otherpay === "Specific Date"){
              document.getElementById("monthspecific").classList.remove("hidden");
              if (this.props.payday > 0){
                // check payday on the monthly calendar
                this.paydaychecked = true;

                document.getElementById("amountdetails").classList.remove("hidden");
                querydataanswer = "#monthspecific [data-answer='"+this.props.payday+"']";
                document.querySelectorAll(querydataanswer)[0].classList.add('picked');

                amountdetails.classList.remove("hidden");
                if (this.props.payamount.length > 0){
                  this.payamountchecked = true;
                  this.detailschecked = true;
                  document.querySelector("label[for='amt']").classList.add("activeamt");
                }
              }
            } else {
              document.getElementById("monthlyweekday").classList.remove("hidden");
              if (this.props.week.length > 0){
                this.payweek = this.props.week;
                this.monthweekchecked = true;
                querydataanswer = "#monthweekbuttons [data-answer='"+this.props.week+"']";
                document.querySelectorAll(querydataanswer)[0].classList.add('picked');
              }
              if (this.props.weekday.length > 0){
                this.monthweekdaychecked = true;
                this.payweekday = this.props.weekday;
                querydataanswer = "#monthweekdaybuttons [data-answer='"+this.props.weekday+"']";
                document.querySelectorAll(querydataanswer)[0].classList.add('picked');
              }
              if (this.monthweekchecked && this.monthweekdaychecked){
                amountdetails.classList.remove("hidden");
                if (this.props.payamount.length > 0){
                  this.payamountchecked = true;
                  this.detailschecked = true;
                  document.querySelector("label[for='amt']").classList.add("activeamt");
                }
              }
            }
          }
        } else if (this.props.payday.length > 0){
          if (this.props.payday === "1" || this.props.payday === "3" || this.props.payday === "Last" || this.props.payday === "2nd Wednesday" || this.props.payday === "3rd Wednesday" || this.props.payday === "4th Wednesday"){
            querydataanswer = "#popmonth [data-answer='"+this.props.payday+"']";
            document.querySelectorAll(querydataanswer)[0].classList.add('picked');
            amountdetails.classList.remove("hidden");
            if (this.props.payamount.length > 0){
              this.payamountchecked = true;
              this.detailschecked = true;
              document.querySelector("label[for='amt']").classList.add("activeamt");
            }
          }
        }
      } else if (this.props.payfrequency === "Semi-Monthly"){
        semimonthlydetails.classList.remove("hidden");
        this.semimonthlychecked = true;
        if (this.props.otherpay.length > 0){
          document.getElementById("popsemiother").classList.add("picked");
          if (this.props.payday > 0){
            // check payday1 on the semi calendar
            this.payday1checked = true;
            this.semifirstpick = this.props.payday;
            [].forEach.call( document.querySelectorAll('.semibutton2'), function(el) {
              el.classList.remove("semibutton");
            });
            document.getElementById("othersemi").classList.remove("hidden");
            querydataanswer = "#othersemi [data-answer='"+this.props.payday+"']";
            document.querySelectorAll(querydataanswer)[0].classList.add('picked');
            if (this.props.payday2 > 0){
              this.payday2checked = true;
              if (!this.props.paytypefilled || this.props.paytypeold === this.props.paymenttype){
                this.lastpayday = this.props.lastpay;
                this.nextpayday = this.props.nextpay;
              }
              querydataanswer = "#othersemi [data-answer='"+this.props.payday2+"']";
              document.querySelectorAll(querydataanswer)[0].classList.add('picked');
              document.querySelectorAll(querydataanswer)[0].classList.add('picked2');
              amountdetails.classList.remove("hidden");
              if (this.props.payamount.length > 0){
                this.payamountchecked = true;
                this.detailschecked = true;
                document.querySelector("label[for='amt']").classList.add("activeamt");
              }
            }
          }
        } else if (this.props.payday > 0 && this.props.payday2 > 0){
          let answer = "";
          if (this.props.payday === 1 && this.props.payday2 === 15){
            answer = "1st & 15th";
          } else if (this.props.payday === 15 && this.props.payday2 === 30){
            answer = "15th & Last";
          } else if (this.props.payday === '05' && this.props.payday2 === 20){
            answer = "5th & 20th";
          } else if (this.props.payday === 10 && this.props.payday2 === 25){
            answer = "10th & 25th";
          } else if (this.props.payday === 7 && this.props.payday2 === 22){
            answer = "7th & 22nd";
          }
          if (answer.length > 0){
            this.payday1checked = true;
            this.payday2checked = true;
            querydataanswer = "[data-answer='"+answer+"']";
            document.querySelectorAll(querydataanswer)[0].classList.add('picked');
            amountdetails.classList.remove("hidden");
            if (this.props.payamount.length > 0){
              this.payamountchecked = true;
              this.detailschecked = true;
              document.querySelector("label[for='amt']").classList.add("activeamt");
            }
          }
        }
      }
    }
  }

  handleFrequencyChange(e) {
    e.preventDefault();

    this.frequencychecked = true;
    [].forEach.call( document.querySelectorAll('.frequencybutton'), function(el) {
      el.classList.remove("picked");
    });

    let frequency = e.target.dataset.answer;
    if (e.target.classList.contains('frequencybutton')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('frequencybutton')){
        frequency = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('frequencybutton')){
        frequency = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.parentNode.classList.contains('frequencybutton')){
        frequency = e.target.parentNode.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.parentNode.parentNode.classList.contains('frequencybutton')){
        frequency = e.target.parentNode.parentNode.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.parentNode.parentNode.classList.add("picked");
      }
    }
    this.props.updateForm("payfrequency", frequency);

    const weeklydetails = document.getElementById("weekdays");
    const biweeklydetails = document.getElementById('biweeklydetails');
    const monthlydetails = document.getElementById("monthlydetails");
    const semimonthlydetails = document.getElementById("semimonthlydetails");
    weeklydetails.classList.add("hidden");
    biweeklydetails.classList.add("hidden");
    monthlydetails.classList.add("hidden");
    semimonthlydetails.classList.add("hidden");
    const amountdetails = document.getElementById("amountdetails");
    amountdetails.classList.add("hidden");

    this.weeklychecked = false;
    this.biweeklychecked = false;
    this.monthlychecked = false;
    this.semimonthlychecked = false;

    this.detailschecked = false;
    if (frequency === "Bi-weekly"){
      weeklydetails.classList.remove("hidden");
      this.biweeklychecked = true;
      if (this.weekdaychecked){
        if (validation.checkAll([true,this.paydatechecked,this.payamountchecked])){
          this.detailschecked = true;
          amountdetails.classList.remove("hidden");
          if (window.pageYOffset < 450)
            scroll.scrollTo(450, {duration: 1200});
        } else {
          if (this.paydatechecked){
            amountdetails.classList.remove("hidden");
            if (window.pageYOffset < 350)
              scroll.scrollTo(350, {duration: 1200});
          } else {
            amountdetails.classList.add("hidden");
            if (window.pageYOffset < 350)
              scroll.scrollTo(350, {duration: 1000});
          }
        }
        biweeklydetails.classList.remove("hidden");
      } else {
        if (window.pageYOffset < 300)
          scroll.scrollTo(300, {duration: 1000});
      }
    } else if (frequency === "Monthly"){
      monthlydetails.classList.remove("hidden");
      this.monthlychecked = true;
      if (validation.checkAll([true,this.paydaychecked,this.payamountchecked])){
        this.detailschecked = true;
        amountdetails.classList.remove("hidden");if (
        window.pageYOffset < 650)
          scroll.scrollTo(650, {duration: 1200});
      } else {
        if (window.pageYOffset < 550)
          scroll.scrollTo(550, {duration: 1000});
      }
    } else if (frequency === "Semi-Monthly"){
      semimonthlydetails.classList.remove("hidden");
      this.semimonthlychecked = true;
      if (validation.checkAll([true,this.payday1checked,this.payday2checked,this.payamountchecked])){
        this.detailschecked = true;
        amountdetails.classList.remove("hidden");
        if (window.pageYOffset < 700)
          scroll.scrollTo(700, {duration: 1200});
      } else {
        if (validation.checkAll([true,this.payday1checked,this.payday2checked])){
          amountdetails.classList.remove("hidden");
          if (window.pageYOffset < 650)
            scroll.scrollTo(650, {duration: 1200});
        } else {
          if (window.pageYOffset < 550)
            scroll.scrollTo(550, {duration: 1000});
        }
      }
    } else if (frequency === "Weekly"){
      weeklydetails.classList.remove("hidden");
      this.weeklychecked = true;
      if (this.payamountchecked){
        amountdetails.classList.remove("hidden");
        this.detailschecked = true;
        if (window.pageYOffset < 350)
          scroll.scrollTo(350, {duration: 1000});
      } else {
        if (window.pageYOffset < 350)
          scroll.scrollTo(350, {duration: 1000});
      }
    }

  }

  handleWeekdayChange(e) {
    e.preventDefault();
    const biweeklydetails = document.getElementById("biweeklydetails");

    this.weekdaychecked = true;

    this.weekday = e.target.dataset.answer;
    [].forEach.call( document.querySelectorAll('.weekdaybutton'), function(el) {
      el.classList.remove("picked");
    });
    if (e.target.classList.contains('weekdaybutton')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('weekdaybutton')){
        this.weekday = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('weekdaybutton')){
        this.weekday = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      }
    }
    this.props.updateForm("weekday", this.weekday);
    //for displaying the dates
    this.lastpaydate = Moment().subtract(1, 'weeks').day(this.weekday).format("MMM D");
    this.prevpaydate = Moment().subtract(2, 'weeks').day(this.weekday).format("MMM D");
    document.getElementById("lastdate").innerHTML = this.lastpaydate;
    document.getElementById("prevdate").innerHTML = this.prevpaydate;
    this.nextpaydate1 = Moment().day(this.weekday).format("MMM D");
    this.nextpaydate2 = Moment().add(1, 'weeks').day(this.weekday).format("MMM D");
    this.props.updateForm("lastpaydate", this.lastpaydate);
    this.props.updateForm("prevpaydate", this.prevpaydate);
    this.props.updateForm("nextpaydate1", this.nextpaydate1);
    this.props.updateForm("nextpaydate2", this.nextpaydate2);

    this.lastpay1 = Moment().subtract(2, 'weeks').day(this.weekday).format("MM/DD/YYYY");
    this.nextpay1 = Moment().day(this.weekday).format("MM/DD/YYYY");
    this.lastpay2 = Moment().subtract(1, 'weeks').day(this.weekday).format("MM/DD/YYYY");
    this.nextpay2 = Moment().add(1, 'weeks').day(this.weekday).format("MM/DD/YYYY");

    if (this.lastpayid === "") {
      biweeklydetails.classList.add("hidden");
    } else {
      if (this.lastpayid === "2") {
        this.nextpaydate = this.nextpaydate2;
      } else {
        this.nextpaydate = this.nextpaydate1;
      }
    }
    const amountdetails = document.getElementById("amountdetails");
    amountdetails.classList.add("hidden");
    this.detailschecked = false;
    if (this.biweeklychecked) {
      biweeklydetails.classList.remove("hidden");
      if (validation.checkAll([true,this.paydatechecked,this.payamountchecked])){
        this.detailschecked = true;
      } else if (this.paydatechecked){
        amountdetails.classList.remove("hidden");
        let amttip = document.getElementById("amttip");
        amttip.classList.add("hidden");
        amttip.innerHTML = "";
        if (window.pageYOffset < 400)
          scroll.scrollTo(400, {duration: 800});
        document.querySelector("label[for='amt']").focus();
      } else {
        if (window.pageYOffset < 400)
          scroll.scrollTo(400, {duration: 800});
      }
    } else if (this.weeklychecked) {
      let todaysmoment = Moment().format("MM/DD/YYYY");
      if (this.nextpay1 < todaysmoment){
        this.props.updateForm("lastpay", this.nextpay1);
        this.props.updateForm("nextpay", this.nextpay2);
      } else {
        this.props.updateForm("lastpay", Moment().subtract(1, 'weeks').day(this.weekday).format("MM/DD/YYYY"));
        this.props.updateForm("nextpay", this.nextpay1);
      }

      amountdetails.classList.remove("hidden");
      let amttip = document.getElementById("amttip");
      amttip.classList.add("hidden");
      amttip.innerHTML = "";
      if (window.pageYOffset < 400)
        scroll.scrollTo(400, {duration: 800});
      document.querySelector("label[for='amt']").focus();

      if (this.payamountchecked)
        this.detailschecked = true;
    }

  }

  handleLastPayChange(e) {
    e.preventDefault();
    this.paydatechecked = true;

    this.lastpayid = e.target.dataset.id;
    [].forEach.call( document.querySelectorAll('.lastpaybutton'), function(el) {
      el.classList.remove("picked");
    });
    if (e.target.classList.contains('lastpaybutton')){
      e.target.classList.add("picked");
    } else if (e.target.parentNode.classList.contains('lastpaybutton')){
      this.lastpayid = e.target.parentNode.dataset.id;
      e.target.parentNode.classList.add("picked");
    }

    if (this.lastpayid === "2") {
      this.nextpaydate = this.nextpaydate2;
      this.props.updateForm("nextpay", this.nextpay2);
      this.props.updateForm("lastpay", this.lastpay2);
    } else {
      this.nextpaydate = this.nextpaydate1;
      this.props.updateForm("nextpay", this.nextpay1);
      this.props.updateForm("lastpay", this.lastpay1);
    }
    document.getElementById("biweeklydetails2").classList.remove("hidden");

    let amttip = document.getElementById("amttip");
    amttip.classList.add("hidden");
    amttip.innerHTML = "";
    document.querySelector("label[for='amt']").focus();
    document.getElementById("amountdetails").classList.remove("hidden");

    if (validation.checkAll([true,this.paydatechecked,this.payamountchecked])){
      this.detailschecked = true;
      if (window.pageYOffset < 600)
        scroll.scrollTo(600, {duration: 1000});
    } else {
      if (window.pageYOffset < 550)
        scroll.scrollTo(550, {duration: 1000});
    }
  }

  weekendCheck(checkdate){

    //weekend check
    let testday = Moment(checkdate).day();

    let momentpay1 = Moment(checkdate).subtract(2, 'days').format('MM/DD/YYYY');
    let momentpay2 = Moment(checkdate).subtract(1, 'days').format('MM/DD/YYYY');
    let momentcheck1 = Moment(checkdate).add(1, 'days').format('MM/DD/YYYY');
    let momentcheck2 = Moment(checkdate).add(2, 'days').format('MM/DD/YYYY');

    if (testday === 0 || testday === 6){
      // show before / after options for holidays and weekends?
      if (testday  === 0){
        if (this.props.paymenttype === "Check"){
          checkdate = momentcheck1;
        } else {
          checkdate = momentpay1;
        }
      } else if (testday === 6){
        if (this.props.paymenttype === "Check"){
          checkdate = momentcheck2;
        } else {
          checkdate = momentpay2;
        }
      }
    }
    return checkdate;
  }

  calcMonthPaydates(payday, payday2=""){
    if (payday === 30 || payday === 31 || payday === "Last"){
      if (this.themonth === 0 || this.themonth === 2 || this.themonth === 4 || this.themonth === 6 || this.themonth === 7 || this.themonth === 9 || this.themonth === 11){
        payday = 31;
      } else if (this.themonth === 1){
        payday = 28;
      }
    }

    if (payday2 > 0){
      this.prevpayday = this.lastmonth+"/"+payday+"/"+this.payyear;
      this.lastpayday = this.lastmonth+"/"+payday2+"/"+this.payyear;
      this.nextpayday = this.paymonth+"/"+payday+"/"+this.payyear;
      if (payday <= this.theday && this.theday < parseInt(payday2, 10)){
        this.prevpayday = this.lastmonth+"/"+payday2+"/"+this.payyear;
        this.lastpayday = this.paymonth+"/"+payday+"/"+this.payyear;
        this.nextpayday = this.paymonth+"/"+payday2+"/"+this.payyear;
      } else if (payday < this.theday && parseInt(payday2, 10) < this.theday){
        this.prevpayday = this.paymonth+"/"+payday+"/"+this.payyear;
        this.lastpayday = this.paymonth+"/"+payday2+"/"+this.payyear;
        this.nextpayday = this.nextmonth+"/"+payday+"/"+this.payyear;
      }
    } else {
      this.lastpayday = this.paymonth+"/"+payday+"/"+this.payyear;
      this.nextpayday = this.nextmonth+"/"+payday+"/"+this.payyear;
      if (this.theday < parseInt(payday,10)){
        this.lastpayday = this.lastmonth+"/"+payday+"/"+this.payyear;
        this.nextpayday = this.paymonth+"/"+payday+"/"+this.payyear;
      }
    }

  }

  handleSemiPopChange(e) {
    e.preventDefault();

    this.payday1checked = true;
    this.payday2checked = true;
    this.props.updateForm("otherpay", '');

    [].forEach.call( document.querySelectorAll('.popsemibutton'), function(el) {
      el.classList.remove("picked");
    });
    let paydays = e.target.dataset.answer;
    if (e.target.classList.contains('popsemibutton')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('popsemibutton')){
        paydays = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('popsemibutton')){
        paydays = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      }
    }
    let payday = 1;
    let payday2 = 15;
    switch (paydays){
      case "15th & Last":
          payday = 15;
          payday2 = 30;
        break;
      case "5th & 20th":
          payday = '05';
          payday2 = 20;
        break;
      case "10th & 25th":
          payday = 10;
          payday2 = 25;
        break;
      case "7th & 22nd":
          payday = 7;
          payday2 = 22;
        break;
      default:
        break;
    }
    this.props.updateForm("payday", payday);
    this.props.updateForm("payday2", payday2);

    this.calcMonthPaydates(payday, payday2);
    //weekend check
    this.prevpayday = this.weekendCheck(this.prevpayday);
    this.lastpayday = this.weekendCheck(this.lastpayday);
    this.nextpayday = this.weekendCheck(this.nextpayday);

    this.props.updateForm("lastpay", this.lastpayday);
    this.props.updateForm("nextpay", this.nextpayday);

    const amountdetails = document.getElementById("amountdetails");
    amountdetails.classList.remove("hidden");
    let amttip = document.getElementById("amttip");
    amttip.classList.add("hidden");
    amttip.innerHTML = "";
    if (window.pageYOffset < 800)
      scroll.scrollTo(800, {duration: 1000});
    if (validation.checkAll([true,this.payamountchecked])){
      this.detailschecked = true;
    } else {
      document.querySelector("label[for='amt']").focus();
    }

    document.getElementById("othersemi").classList.add("hidden");
  }

  handleSemiOtherChange(e) {
    e.preventDefault();

    this.props.updateForm("otherpay", 'Yes');
    this.props.updateForm("payday", '');
    this.props.updateForm("payday2", '');
    this.props.updateForm("lastpay", '');
    this.props.updateForm("nextpay", '');
    this.payday1checked = false;
    this.payday2checked = false;
    this.detailschecked = false;
    [].forEach.call( document.querySelectorAll('.semibutton2'), function(el) {
      el.classList.add("semibutton");
      el.classList.remove("picked");
    });
    const amountdetails = document.getElementById("amountdetails");
    amountdetails.classList.add("hidden");

    [].forEach.call( document.querySelectorAll('.popsemibutton'), function(el) {
      el.classList.remove("picked");
    });
    document.getElementById("popsemiother").classList.add("picked");

    const othersemi = document.getElementById("othersemi");
    othersemi.classList.remove("hidden");

    let amttip = document.getElementById("amttip");
    amttip.classList.add("hidden");
    amttip.innerHTML = "";

    if (window.pageYOffset < 900)
      scroll.scrollTo(900, {duration: 1000});
  }

  handleSemiChange(e) {
    e.preventDefault();

    const amountdetails = document.getElementById("amountdetails");
    amountdetails.classList.add("hidden");

    //moving backward - picked a tile that's already selected
    if (e.target.classList.contains('picked') || e.target.parentNode.classList.contains('picked') || e.target.parentNode.parentNode.classList.contains('picked')){

      if (e.target.classList.contains('picked')){
        e.target.classList.remove("picked");
      } else {
        if (e.target.parentNode.classList.contains('picked')){
          e.target.parentNode.classList.remove("picked");
        } else if (e.target.parentNode.parentNode.classList.contains('picked')){
          e.target.parentNode.parentNode.classList.remove("picked");
        }
      }

      if (e.target.classList.contains('semibutton2') || e.target.parentNode.classList.contains('semibutton2') || e.target.parentNode.parentNode.classList.contains('semibutton2')){
        [].forEach.call( document.querySelectorAll('.semibutton2'), function(el) {
          el.classList.add("semibutton");
        });
        this.payday2checked = false;
        this.props.updateForm("payday2", "");
      } else {
        this.payday1checked = false;
        this.props.updateForm("payday", "");
        this.semifirstpick = "";
      }

    //moving forward
    } else {
      //first date picked
      if (e.target.classList.contains('semibutton') || e.target.parentNode.classList.contains('semibutton') || e.target.parentNode.parentNode.classList.contains('semibutton')){
        [].forEach.call( document.querySelectorAll('.semibutton'), function(el) {
          el.classList.remove("picked");
        });

        let payday = "";
        if (e.target.classList.contains('semibutton')){
          payday = e.target.dataset.answer;
          e.target.classList.add("picked");
        } else {
          if (e.target.parentNode.classList.contains('semibutton')){
            payday = e.target.parentNode.dataset.answer;
            e.target.parentNode.classList.add("picked");
          } else if (e.target.parentNode.parentNode.classList.contains('semibutton')){
            payday = e.target.parentNode.parentNode.dataset.answer;
            e.target.parentNode.parentNode.classList.add("picked");
          }
        }
        this.semifirstpick = parseInt(payday, 10);
        this.props.updateForm("payday", this.semifirstpick);

        [].forEach.call( document.querySelectorAll('.semibutton2'), function(el) {
          el.classList.remove("semibutton");
        });

        this.payday1checked = true;
        this.payday2checked = false;

      } else {
        //second date picked
        if (this.payday2checked) {
          [].forEach.call( document.querySelectorAll('.picked2'), function(el) {
            el.classList.remove("picked");
          });
        }

        let payday2 = "";
        if (e.target.classList.contains('semibutton2')){
          payday2 = e.target.dataset.answer;
          e.target.classList.add("picked");
          e.target.classList.add("picked2");
        } else {
          if (e.target.parentNode.classList.contains('semibutton2')){
            payday2 = e.target.parentNode.dataset.answer;
            e.target.parentNode.classList.add("picked");
            e.target.parentNode.classList.add("picked2");
          } else if (e.target.parentNode.parentNode.classList.contains('semibutton2')){
            payday2 = e.target.parentNode.parentNode.dataset.answer;
            e.target.parentNode.parentNode.classList.add("picked");
            e.target.parentNode.parentNode.classList.add("picked2");
          }
        }
        if (payday2 < this.semifirstpick && this.props.payday2.length === 0){
          let temp = this.semifirstpick;
          this.semifirstpick = parseInt(payday2, 10);
          payday2 = temp;
        }

        this.props.updateForm("payday2", payday2);

        this.calcMonthPaydates(this.semifirstpick,payday2);

        //weekend check
        this.prevpayday = this.weekendCheck(this.prevpayday);
        this.lastpayday = this.weekendCheck(this.lastpayday);
        this.nextpayday = this.weekendCheck(this.nextpayday);

        this.props.updateForm("lastpay", this.lastpayday);
        this.props.updateForm("nextpay", this.nextpayday);
        this.payday2checked = true;

        amountdetails.classList.remove("hidden");
        let amttip = document.getElementById("amttip");
        amttip.classList.add("hidden");
        amttip.innerHTML = "";
        if (validation.checkAll([true,this.payamountchecked])){
          this.detailschecked = true;
          if (window.pageYOffset < 1200)
            scroll.scrollTo(1200, {duration: 1000});
        } else {
          document.querySelector("label[for='amt']").focus();
          if (window.pageYOffset < 1100)
            scroll.scrollTo(1100, {duration: 1000});
        }
      }
    }
  }

  getLastWeekOfMonth(weekday, weekmth){
      if (weekmth === '02' || weekmth === '2'){
        return 4;
      }
      // } else if (weekday === 1 || weekday === '1'){
      //   if (weekmth === '01' || weekmth === '03' || weekmth === '05' || weekmth === 07 || weekmth === '08' || weekmth === '10' || weekmth === '12'){
      //     let firstofmth = Moment().startOf('month');
      //     let lastofmth = Moment().endOf('month');
      //     // if first day of the month is on a weekend and last day of the month is on Monday
      //     if (firstofmth.day() % 6 === 0 && lastofmth.day() % 1 === 0)
      //       return 6;
      //   }
      // }
      return 5;
  }

  chooseWeekDay(weekday){
    let getweekday = Moment().day(weekday).format("DD");
    let getweekmonth = Moment().day(weekday).format("MM");
    let getweekyear = Moment().day(weekday).format("YYYY");
    let newmoment = Moment(getweekyear+"-"+getweekmonth+"-"+getweekday);

    let weekofmonth = Math.ceil(newmoment.date() / 7);
    let paywk = this.payweek;
    if (paywk === "Last"){
      paywk = this.getLastWeekOfMonth(weekday, getweekmonth);
    }
    let difference = parseInt(paywk, 10) - weekofmonth;

    let todaymoment = Moment(this.today);

    if (difference === 0){
      if (newmoment <= todaymoment){
       this.lastpayday = Moment().day(weekday).format("MM/DD/YYYY");
       this.prevpayday = Moment().subtract(1, 'months').day(weekday).format("MM/DD/YYYY");
       this.nextpayday = Moment().add(1, 'months').day(weekday).format("MM/DD/YYYY");
       this.props.updateForm("lastpay", this.lastpayday);
       this.props.updateForm("nextpay", this.nextpayday);
      } else {
       this.lastpayday = Moment().subtract(1, 'months').day(weekday).format("MM/DD/YYYY");
       this.prevpayday = Moment().subtract(2, 'months').format("MM/DD/YYYY");
       this.nextpayday = Moment().day(weekday).format("MM/DD/YYYY");
       this.props.updateForm("lastpay", this.lastpayday);
       this.props.updateForm("nextpay", this.nextpayday);
      }
    } else {
      //need to calculate the date based on the difference
      let newday = parseInt(getweekday,10) + (difference*7);
      let weekdate = getweekyear+"-"+getweekmonth+"-"+newday;

      newmoment = Moment(weekdate);
      //need to calculate day base it on weeks in the month
      let extraweeks = 5;
      if (getweekmonth == '02'){
        extraweeks = 4;
      }
      let subtractweeks = 4 + extraweeks;

      if (newmoment <= todaymoment){
         this.lastpayday = Moment(weekdate).format("MM/DD/YYYY");
         this.prevpayday = Moment(weekdate).subtract(4, 'weeks').format("MM/DD/YYYY");
         this.nextpayday = Moment(weekdate).add(extraweeks, 'weeks').format("MM/DD/YYYY");
         this.props.updateForm("lastpay", this.lastpayday);
         this.props.updateForm("nextpay", this.nextpayday);
      } else {
         this.lastpayday = Moment(weekdate).subtract(4, 'weeks').format("MM/DD/YYYY");
         this.prevpayday = Moment(weekdate).subtract(subtractweeks, 'weeks').format("MM/DD/YYYY");
         this.nextpayday = Moment(weekdate).format("MM/DD/YYYY");
         this.props.updateForm("lastpay", this.lastpayday);
         this.props.updateForm("nextpay", this.nextpayday);
      }
    }
  }

  handleMonthPopChange(e) {
    e.preventDefault();

    this.paydaychecked = true;

    [].forEach.call( document.querySelectorAll('.popmonthlybutton'), function(el) {
      el.classList.remove("picked");
    });
    let payday = e.target.dataset.answer;
    if (e.target.classList.contains('popmonthlybutton')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('popmonthlybutton')){
        payday = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('popmonthlybutton')){
        payday = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      }
    }

    this.props.updateForm("payday", payday);

    if (payday === "Last"){
      this.calcMonthPaydates(30);
      //weekend check
      this.lastpayday = this.weekendCheck(this.lastpayday);
      this.nextpayday = this.weekendCheck(this.nextpayday);

      this.props.updateForm("lastpay", this.lastpayday);
      this.props.updateForm("nextpay", this.nextpayday);
    } else if (payday.includes("Wednesday")){
      this.payweek = payday[0];
      const wednesday = 3;
      this.chooseWeekDay(wednesday);
    } else {
      this.calcMonthPaydates(payday);

      //weekend check
      this.lastpayday = this.weekendCheck(this.lastpayday);
      this.nextpayday = this.weekendCheck(this.nextpayday);

      this.props.updateForm("lastpay", this.lastpayday);
      this.props.updateForm("nextpay", this.nextpayday);
    }
    document.getElementById("monthspecific").classList.add("hidden");
    document.getElementById("monthlyweekday").classList.add("hidden");
    document.getElementById("othermonth").classList.add("hidden");

    const amountdetails = document.getElementById("amountdetails");
    amountdetails.classList.remove("hidden");
    let amttip = document.getElementById("amttip");
    amttip.classList.add("hidden");
    amttip.innerHTML = "";
    document.querySelector("label[for='amt']").focus();
    if (window.pageYOffset < 800)
      scroll.scrollTo(800, {duration: 1000});

    if (validation.checkAll([true,this.payamountchecked])){
      this.detailschecked = true;
    }
  }

  handleMonthOtherChange(e) {
    e.preventDefault();

    this.props.updateForm("otherpay", 'Yes');
    [].forEach.call( document.querySelectorAll('.popmonthlybutton'), function(el) {
      el.classList.remove("picked");
    });
    document.getElementById("popmonthlyother").classList.add("picked");

    this.props.updateForm("payday", '');
    this.props.updateForm("lastpay", '');
    this.props.updateForm("nextpay", '');
    this.paydaychecked = false;
    this.detailschecked = false;
    let amttip = document.getElementById("amttip");
    amttip.classList.add("hidden");
    amttip.innerHTML = "";
    document.getElementById("amountdetails").classList.add("hidden");

    document.getElementById("othermonth").classList.remove("hidden");
    if (window.pageYOffset < 900)
      scroll.scrollTo(900, {duration: 1000});

  }

  handleMonthChoiceChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.monthlyweekdaychoice'), function(el) {
      el.classList.remove("picked");
    });
    let choice = e.target.dataset.answer;
    if (e.target.classList.contains('monthlyweekdaychoice')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('monthlyweekdaychoice')){
        choice = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('monthlyweekdaychoice')){
        choice = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      }
    }
    this.props.updateForm("otherpay", choice);
    if (choice === "Specific Date"){
      document.getElementById("monthspecific").classList.remove("hidden");
      if (window.pageYOffset < 1200)
        scroll.scrollTo(1200, {duration: 1000});
      document.getElementById("monthlyweekday").classList.add("hidden");
    } else {
      document.getElementById("monthlyweekday").classList.remove("hidden");
      if (window.pageYOffset < 1100)
        scroll.scrollTo(1100, {duration: 1000});
      document.getElementById("monthspecific").classList.add("hidden");
    }
  }

  handleMonthWeekChange(e) {
    e.preventDefault();

    this.monthweekchecked = true;

    let week = e.target.dataset.answer;
    [].forEach.call( document.querySelectorAll('.monthweekbutton'), function(el) {
      el.classList.remove("picked");
    });
    if (e.target.classList.contains('monthweekbutton')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('monthweekbutton')){
        week = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('monthweekbutton')){
        week = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      }
    }
    this.payweek = week;
    this.props.updateForm("week", week);

    const amountdetails = document.getElementById("amountdetails");

    if (this.monthweekdaychecked){
      this.paydaychecked = true;

      this.chooseWeekDay(this.payweekday);

      amountdetails.classList.remove("hidden");
      let amttip = document.getElementById("amttip");
      amttip.classList.add("hidden");
      amttip.innerHTML = "";

      if (validation.checkAll([true,this.monthweekdaychecked,this.payamountchecked])){
        this.paydaychecked = true;
        this.detailschecked = true;
        if (window.pageYOffset < 1300)
          scroll.scrollTo(1300, {duration: 1000});
      } else {
        document.querySelector("label[for='amt']").focus();
        if (window.pageYOffset < 1200)
          scroll.scrollTo(1200, {duration: 1000});
      }
    } else {
      if (window.pageYOffset < 1100)
        scroll.scrollTo(1100, {duration: 1000});
    }

  }

  handleMonthWeekdayChange(e) {
    e.preventDefault();
    this.monthweekdaychecked = true;

    let weekday = e.target.dataset.answer;
    [].forEach.call( document.querySelectorAll('.monthweekdaybutton'), function(el) {
      el.classList.remove("picked");
    });
    if (e.target.classList.contains('monthweekdaybutton')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('monthweekdaybutton')){
        weekday = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('monthweekdaybutton')){
        weekday = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      }
    }

    this.payweekday = weekday;

    this.props.updateForm("weekday", weekday);

    if (this.monthweekchecked){
      this.chooseWeekDay(weekday);
    }

    const amountdetails = document.getElementById("amountdetails");
    if (validation.checkAll([true,this.monthweekchecked,this.payamountchecked])){
      this.paydaychecked = true;
      this.detailschecked = true;
      if (window.pageYOffset < 1300)
        scroll.scrollTo(1300, {duration: 1000});
    } else {
        if (this.monthweekchecked){
        this.paydaychecked = true;
        amountdetails.classList.remove("hidden");
        let amttip = document.getElementById("amttip");
        amttip.classList.add("hidden");
        amttip.innerHTML = "";
        document.querySelector("label[for='amt']").focus();
        if (window.pageYOffset < 1300)
          scroll.scrollTo(1300, {duration: 1000});
      }
    }
  }

  handleMonthChange(e) {
    e.preventDefault();

    this.paydaychecked = true;

    document.getElementById("amountdetails").classList.remove("hidden");
    let amttip = document.getElementById("amttip");
    amttip.classList.add("hidden");
    amttip.innerHTML = "";
    document.querySelector("label[for='amt']").focus();

    [].forEach.call( document.querySelectorAll('.monthbutton'), function(el) {
      el.classList.remove("picked");
    });
    let payday = e.target.dataset.answer;
    if (e.target.classList.contains('monthbutton')){
      e.target.classList.add("picked");
    } else {
      if (e.target.parentNode.classList.contains('monthbutton')){
        payday = e.target.parentNode.dataset.answer;
        e.target.parentNode.classList.add("picked");
      } else if (e.target.parentNode.parentNode.classList.contains('monthbutton')){
        payday = e.target.parentNode.parentNode.dataset.answer;
        e.target.parentNode.parentNode.classList.add("picked");
      }
    }
    this.props.updateForm("payday", payday);
    //date
    this.calcMonthPaydates(payday);
    //weekend check
    this.lastpayday = this.weekendCheck(this.lastpayday);
    this.nextpayday = this.weekendCheck(this.nextpayday);

    this.props.updateForm("lastpay", this.lastpayday);
    this.props.updateForm("nextpay", this.nextpayday);

    if (validation.checkAll([true,this.payamountchecked])){
      this.detailschecked = true;
    }
    if (window.pageYOffset < 1300)
      scroll.scrollTo(1300, {duration: 1000});
  }

  handlePayAmountChange(e) {
    let amt = e.target.value;

    this.props.updateForm("payamount", amt);

    let amttip = document.getElementById("amttip");
    const amtlabel = document.querySelector("label[for='amt']");

    if (amt.length > 0){
      this.payamountchecked = true;
      amttip.classList.add("hidden");
      amttip.innerHTML = "";

      if (validation.checkAll([true,this.weeklychecked,this.weekdaychecked])){
        this.detailschecked = true;
      } else if (validation.checkAll([true,this.biweeklychecked,this.weekdaychecked,this.paydatechecked])){
        this.detailschecked = true;
      } else if (validation.checkAll([true,this.monthlychecked,this.paydaychecked])){
        this.detailschecked = true;
      } else if (validation.checkAll([true,this.semimonthlychecked,this.payday1checked,this.payday2checked])){
        this.detailschecked = true;
      }
      amtlabel.classList.add("activeamt");
    } else {
      this.payamountchecked = false;
      amtlabel.classList.remove("activeamt");
    }
  }

  handlePayAmountBlur(e) {
    if (e.target.value.length < 1){
      let amttip = document.getElementById("amttip");
      amttip.innerHTML = "Please enter the amount of your last paycheck.";
      amttip.classList.remove("hidden");
    }

  }

  render() {

    const thismonth = this.today.getMonth();

    const nextFinance = 1;
    const nextLink = "/bankinginfo";
    const btnText = "Continue";
    const btnClasses = "btn next-step";

      return (
        <AccountLayout>
          <div className="container" id="stepper-step-3">
            <div className="text-center topcopy">
                <h1>When do you get paid?</h1>
            </div>
            <hr />

            <form className="flowform">
              <div className="tilebutton-group text-center">
                  <div id="payfrequencybuttons" className="button-group">
                    <a className="btn mutedstrip-radio frequencybutton" data-answer="Bi-weekly" onClick={this.handleFrequencyChange} tabIndex="1">
                      <div></div><span>Every other week <strong style={{display:'inline-block'}}>(Bi-Weekly)</strong></span>
                    </a>
                    <a className="btn mutedstrip-radio frequencybutton" data-answer="Monthly" onClick={this.handleFrequencyChange} tabIndex="2">
                      <div></div><span>Once a month (Monthly)</span>
                    </a>
                    <a className="btn mutedstrip-radio frequencybutton" data-answer="Weekly" onClick={this.handleFrequencyChange} tabIndex="3">
                      <div></div><span>Once a week (Weekly)</span>
                    </a>
                    <a className="btn mutedstrip-radio frequencybutton" data-answer="Semi-Monthly" onClick={this.handleFrequencyChange} tabIndex="4">
                      <div></div><span>Twice a month <strong style={{display:'inline-block'}}>(Semi-Monthly)</strong></span>
                    </a>
                  </div>
                  <div className="cf"></div>
                  <p className="padtop10"><AlertDialogSlide linkText="What’s the difference?" tip="difference" linkImage="images/svg/info.svg" /></p>
              </div>

              <hr />

              <div id="weekdays" className="weekly biweekly hidden">
                <p className="buttontitle">What day of the week?</p>
                <div className="button-group circle-btn-group">
                    <a className="btn circle-btn weekdaybutton" data-answer="1" onClick={this.handleWeekdayChange} tabIndex="5">
                      <div>
                        <span>Mon</span>
                      </div>
                    </a>
                    <a className="btn circle-btn weekdaybutton" data-answer="2" onClick={this.handleWeekdayChange} tabIndex="6">
                      <div>
                        <span>Tue</span>
                      </div>
                    </a>
                    <a className="btn circle-btn weekdaybutton" data-answer="3" onClick={this.handleWeekdayChange} tabIndex="7">
                      <div>
                        <span>Wed</span>
                      </div>
                    </a>
                    <a className="btn circle-btn weekdaybutton" data-answer="4" onClick={this.handleWeekdayChange} tabIndex="8">
                      <div>
                        <span>Thu</span>
                      </div>
                    </a>
                    <a className="btn circle-btn weekdaybutton" data-answer="5" onClick={this.handleWeekdayChange} tabIndex="9">
                      <div>
                        <span>Fri</span>
                      </div>
                    </a>
                </div>
              </div>

              <div id="biweeklydetails" className="biweekly hidden">
                <hr />
                <div className="form-group">
                  <p className="buttontitle">When was your last pay date?</p>
                  <div className="button-group">
                    <a className="btn rectangle-btn lastpaybutton" data-answer={this.props.prevpaydate} data-day={this.weekday} data-full={this.props.prevpaydate} data-id="1" onClick={this.handleLastPayChange} tabIndex="5">
                        <span id="prevdate">{this.props.prevpaydate}</span>
                    </a>
                    <a className="btn rectangle-btn lastpaybutton" data-answer={this.props.lastpaydate} data-day={this.weekday} data-full={this.props.lastpaydate} data-id="2" onClick={this.handleLastPayChange} tabIndex="6">
                        <span id="lastdate">{this.props.lastpaydate}</span>
                    </a>
                  </div>
                </div>
                <div id="biweeklydetails2" className="hidden">
                  <div className="form-group">
                    <p className="buttontitle">Your next pay date: <span style={{color:'#1565c0'}}>{this.nextpaydate}</span></p>
                  </div>
                </div>
              </div>

              <div id="semimonthlydetails" className="semimonthly hidden">
                  <p className="buttontitle">Select your two pay days</p>
                  <div className="button-group">
                    <a className="btn mutedstrip-radio popsemibutton" data-answer="1st & 15th" onClick={this.handleSemiPopChange} tabIndex="5">
                      <div></div><span>1st & 15th of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popsemibutton" data-answer="15th & Last" onClick={this.handleSemiPopChange} tabIndex="6">
                      <div></div><span>15th & Last of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popsemibutton" data-answer="5th & 20th" onClick={this.handleSemiPopChange} tabIndex="7">
                      <div></div><span>5th & 20th of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popsemibutton" data-answer="10th & 25th" onClick={this.handleSemiPopChange} tabIndex="8">
                      <div></div><span>10th & 25th of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popsemibutton" data-answer="7th & 22nd" onClick={this.handleSemiPopChange} tabIndex="9">
                      <div></div><span>7th & 22nd of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popsemibutton" id="popsemiother" data-answer="Other" onClick={this.handleSemiOtherChange} tabIndex="10">
                      <div></div><span>I don&#39;t see my pay date</span>
                    </a>
                  </div>

                  <div id="othersemi" className="hidden">
                    <p className="buttontitle">Select your <span style={{textDecoration:'underline',fontSize:'21px'}}>two</span> pay dates:</p>
                    <div className="button-group month-group">
                      <a className="btn month-square semibutton semibutton2" data-answer="1" onClick={this.handleSemiChange} tabIndex="11">
                        <div>
                          <span>1</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="2" onClick={this.handleSemiChange} tabIndex="12">
                        <div>
                          <span>2</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="3" onClick={this.handleSemiChange} tabIndex="13">
                        <div>
                          <span>3</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="4" onClick={this.handleSemiChange} tabIndex="14">
                        <div>
                          <span>4</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="5" onClick={this.handleSemiChange} tabIndex="15">
                        <div>
                          <span>5</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="6" onClick={this.handleSemiChange} tabIndex="16">
                        <div>
                          <span>6</span>
                        </div>
                      </a>
                    </div>
                    <div className="button-group month-group">
                      <a className="btn month-square semibutton semibutton2" data-answer="7" onClick={this.handleSemiChange} tabIndex="17">
                        <div>
                          <span>7</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="8" onClick={this.handleSemiChange} tabIndex="18">
                        <div>
                          <span>8</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="9" onClick={this.handleSemiChange} tabIndex="19">
                        <div>
                          <span>9</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="10" onClick={this.handleSemiChange} tabIndex="20">
                        <div>
                          <span>10</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="11" onClick={this.handleSemiChange} tabIndex="21">
                        <div>
                          <span>11</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="12" onClick={this.handleSemiChange} tabIndex="22">
                        <div>
                          <span>12</span>
                        </div>
                      </a>
                    </div>
                    <div className="button-group month-group">
                      <a className="btn month-square semibutton semibutton2" data-answer="13" onClick={this.handleSemiChange} tabIndex="23">
                        <div>
                          <span>13</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="14" onClick={this.handleSemiChange} tabIndex="24">
                        <div>
                          <span>14</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="15" onClick={this.handleSemiChange} tabIndex="25">
                        <div>
                          <span>15</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="16" onClick={this.handleSemiChange} tabIndex="26">
                        <div>
                          <span>16</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="17" onClick={this.handleSemiChange} tabIndex="27">
                        <div>
                          <span>17</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="18" onClick={this.handleSemiChange} tabIndex="28">
                        <div>
                          <span>18</span>
                        </div>
                      </a>
                    </div>
                    <div className="button-group month-group">
                      <a className="btn month-square semibutton semibutton2" data-answer="19" onClick={this.handleSemiChange} tabIndex="29">
                        <div>
                          <span>19</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="20" onClick={this.handleSemiChange} tabIndex="30">
                        <div>
                          <span>20</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="21" onClick={this.handleSemiChange} tabIndex="31">
                        <div>
                          <span>21</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="22" onClick={this.handleSemiChange} tabIndex="32">
                        <div>
                          <span>22</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="23" onClick={this.handleSemiChange} tabIndex="33">
                        <div>
                          <span>23</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="24" onClick={this.handleSemiChange} tabIndex="34">
                        <div>
                          <span>24</span>
                        </div>
                      </a>
                    </div>
                    <div className="button-group month-group" style={{textAlign:'left'}}>
                      <a className="btn month-square semibutton semibutton2" data-answer="25" onClick={this.handleSemiChange} tabIndex="35">
                        <div>
                          <span>25</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="26" onClick={this.handleSemiChange} tabIndex="36">
                        <div>
                          <span>26</span>
                        </div>
                      </a>
                      <a className="btn month-square semibutton semibutton2" data-answer="27" onClick={this.handleSemiChange} tabIndex="37">
                        <div>
                          <span>27</span>
                        </div>
                      </a>
                      {thismonth !== 1 && <a className="btn month-square semibutton semibutton2" data-answer="28" onClick={this.handleSemiChange} tabIndex="38">
                        <div>
                          <span>28</span>
                        </div>
                      </a>}
                      {thismonth !== 1 && <a className="btn month-square semibutton semibutton2" data-answer="29" onClick={this.handleSemiChange} tabIndex="39">
                        <div>
                          <span>29</span>
                        </div>
                      </a>}
                      <a className="btn month-square semibutton semibutton2" data-answer="30" onClick={this.handleSemiChange} tabIndex="40">
                        <div>
                          <span>Last</span>
                        </div>
                      </a>
                    </div>
                    <div className="cf"></div>
                  </div>
              </div>

              <div id="monthlydetails" className="monthly hidden">
                <div className="form-group">
                  <div className="errortip hidden" id="semitip">
                      Please select your pay date.
                  </div>
                  <p className="buttontitle">Select your pay day</p>
                  <div id="popmonth" className="button-group">
                    <a className="btn mutedstrip-radio popmonthlybutton" data-answer="1" onClick={this.handleMonthPopChange} tabIndex="5">
                      <div></div><span>First of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popmonthlybutton" data-answer="3" onClick={this.handleMonthPopChange} tabIndex="6">
                      <div></div><span>Third of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popmonthlybutton" data-answer="Last" onClick={this.handleMonthPopChange} tabIndex="7">
                      <div></div><span>Last day of the month</span>
                    </a>
                    <a className="btn mutedstrip-radio popmonthlybutton" data-answer="2nd Wednesday" onClick={this.handleMonthPopChange} tabIndex="8">
                      <div></div><span>2nd Wednesday of month</span>
                    </a>
                    <a className="btn mutedstrip-radio popmonthlybutton" data-answer="3rd Wednesday" onClick={this.handleMonthPopChange} tabIndex="9">
                      <div></div><span>3rd Wednesday of month</span>
                    </a>
                    <a className="btn mutedstrip-radio popmonthlybutton" data-answer="4th Wednesday" onClick={this.handleMonthPopChange} tabIndex="10">
                      <div></div><span>4th Wednesday of month</span>
                    </a>
                    <a className="btn mutedstrip-radio popmonthlybutton" id="popmonthlyother" data-answer="Other" onClick={this.handleMonthOtherChange} tabIndex="11">
                      <div></div><span>I don&#39;t see my pay date</span>
                    </a>
                  </div>


                  <div id="othermonth" className="hidden">
                    <p className="buttontitle">When do you get paid?</p>
                    <div className="button-group">
                      <a className="btn mutedstrip-radio monthlyweekdaychoice" data-answer="Specific Date" onClick={this.handleMonthChoiceChange} tabIndex="12">
                        <div></div><span>On same date each month</span>
                      </a>
                      <a className="btn mutedstrip-radio monthlyweekdaychoice" data-answer="Day of the Week" onClick={this.handleMonthChoiceChange} tabIndex="13">
                        <div></div><span>On same day of the week</span>
                      </a>
                    </div>
                  </div>
                  <div id="monthspecific" className="hidden">
                    <p className="buttontitle">Select a day of the month</p>
                    <div className="button-group month-group">
                        <a className="btn month-square monthbutton" data-answer="1" onClick={this.handleMonthChange} tabIndex="14">
                          <div>
                            <span>1</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="2" onClick={this.handleMonthChange} tabIndex="15">
                          <div>
                            <span>2</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="3" onClick={this.handleMonthChange} tabIndex="16">
                          <div>
                            <span>3</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="4" onClick={this.handleMonthChange} tabIndex="17">
                          <div>
                            <span>4</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="5" onClick={this.handleMonthChange} tabIndex="18">
                          <div>
                            <span>5</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="6" onClick={this.handleMonthChange} tabIndex="19">
                          <div>
                            <span>6</span>
                          </div>
                        </a>
                    </div>
                    <div className="button-group month-group">
                        <a className="btn month-square monthbutton" data-answer="7" onClick={this.handleMonthChange} tabIndex="20">
                          <div>
                            <span>7</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="8" onClick={this.handleMonthChange} tabIndex="21">
                          <div>
                            <span>8</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="9" onClick={this.handleMonthChange} tabIndex="22">
                          <div>
                            <span>9</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="10" onClick={this.handleMonthChange} tabIndex="23">
                          <div>
                            <span>10</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="11" onClick={this.handleMonthChange} tabIndex="24">
                          <div>
                            <span>11</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="12" onClick={this.handleMonthChange} tabIndex="25">
                          <div>
                            <span>12</span>
                          </div>
                        </a>
                    </div>
                    <div className="button-group month-group">
                        <a className="btn month-square monthbutton" data-answer="13" onClick={this.handleMonthChange} tabIndex="26">
                          <div>
                            <span>13</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="14" onClick={this.handleMonthChange} tabIndex="27">
                          <div>
                            <span>14</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="15" onClick={this.handleMonthChange} tabIndex="28">
                          <div>
                            <span>15</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="16" onClick={this.handleMonthChange} tabIndex="29">
                          <div>
                            <span>16</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="17" onClick={this.handleMonthChange} tabIndex="30">
                          <div>
                            <span>17</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="18" onClick={this.handleMonthChange} tabIndex="31">
                          <div>
                            <span>18</span>
                          </div>
                        </a>
                    </div>
                    <div className="button-group month-group">
                        <a className="btn month-square monthbutton" data-answer="19" onClick={this.handleMonthChange} tabIndex="32">
                          <div>
                            <span>19</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="20" onClick={this.handleMonthChange} tabIndex="33">
                          <div>
                            <span>20</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="21" onClick={this.handleMonthChange} tabIndex="34">
                          <div>
                            <span>21</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="22" onClick={this.handleMonthChange} tabIndex="35">
                          <div>
                            <span>22</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="23" onClick={this.handleMonthChange} tabIndex="36">
                          <div>
                            <span>23</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="24" onClick={this.handleMonthChange} tabIndex="37">
                          <div>
                            <span>24</span>
                          </div>
                        </a>
                    </div>
                    <div className="button-group month-group" style={{textAlign:'left'}}>
                        <a className="btn month-square monthbutton" data-answer="25" onClick={this.handleMonthChange} tabIndex="38">
                          <div>
                            <span>25</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="26" onClick={this.handleMonthChange} tabIndex="39">
                          <div>
                            <span>26</span>
                          </div>
                        </a>
                        <a className="btn month-square monthbutton" data-answer="27" onClick={this.handleMonthChange} tabIndex="40">
                          <div>
                            <span>27</span>
                          </div>
                        </a>
                        {thismonth !== 1 && <a className="btn month-square monthbutton" data-answer="28" onClick={this.handleMonthChange} tabIndex="41">
                          <div>
                            <span>28</span>
                          </div>
                        </a>}
                        {thismonth !== 1 && <a className="btn month-square monthbutton" data-answer="29" onClick={this.handleMonthChange} tabIndex="42">
                          <div>
                            <span>29</span>
                          </div>
                        </a>}
                        <a className="btn month-square monthbutton" data-answer="30" onClick={this.handleMonthChange} tabIndex="43">
                          <div>
                            <span>Last</span>
                          </div>
                        </a>
                    </div>
                </div>

                <div id="monthlyweekday" className="hidden">
                  <p className="buttontitle">Week</p>
                  <div id="monthweekbuttons" className="button-group circle-btn-group">
                    <a className="btn circle-btn monthweekbutton" data-answer="1" onClick={this.handleMonthWeekChange} tabIndex="14">
                      <div>
                        <span>1st</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekbutton" data-answer="2" onClick={this.handleMonthWeekChange} tabIndex="15">
                      <div>
                        <span>2nd</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekbutton" data-answer="3" onClick={this.handleMonthWeekChange} tabIndex="16">
                      <div>
                        <span>3rd</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekbutton" data-answer="4" onClick={this.handleMonthWeekChange} tabIndex="17">
                      <div>
                        <span>4th</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekbutton" data-answer="Last" onClick={this.handleMonthWeekChange} tabIndex="18">
                      <div>
                        <span>Last</span>
                      </div>
                    </a>
                  </div>
                  <p className="buttontitle">Weekday</p>
                  <div id="monthweekdaybuttons" className="button-group circle-btn-group">
                    <a className="btn circle-btn monthweekdaybutton" data-answer="1" onClick={this.handleMonthWeekdayChange} tabIndex="19">
                      <div>
                        <span>Mon</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekdaybutton" data-answer="2" onClick={this.handleMonthWeekdayChange} tabIndex="20">
                      <div>
                        <span>Tue</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekdaybutton" data-answer="3" onClick={this.handleMonthWeekdayChange} tabIndex="21">
                      <div>
                        <span>Wed</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekdaybutton" data-answer="4" onClick={this.handleMonthWeekdayChange} tabIndex="22">
                      <div>
                        <span>Thu</span>
                      </div>
                    </a>
                    <a className="btn circle-btn monthweekdaybutton" data-answer="5" onClick={this.handleMonthWeekdayChange} tabIndex="23">
                      <div>
                        <span>Fri</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              </div>

              <div id="amountdetails" className="form-group hidden padtop">
                <div className="errortip hidden" id="amttip">
                    Please provide your paycheck amount.
                </div>
                <label htmlFor="amt">
                  How much was your last paycheck (after deductions)?
                  <input style={{paddingLeft:'20px'}} type="number" id="amt" name="amt" className="form-control" value={this.props.payamount} onChange={this.handlePayAmountChange} onBlur={this.handlePayAmountBlur} tabIndex="44" />
                  <p style={{position:'absolute',bottom:'0px',left:'10px',fontWeight:'400'}}>$</p>
                </label>
              </div>

              <NextFinanceButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.detailschecked} hideNext={!this.frequencychecked} financestep={nextFinance} tabIndex="45" />

            </form>
          </div>
        </AccountLayout>
        );
    }
}
//<input type="text" className="form-control" name="payday1" id="payday1" value={this.props.lastpay} onChange={this.handleMonthlyLastChange} onBlur={this.handleMonthlyLastBlur} tabIndex="5" />
//<input type="text" className="form-control" name="payday2" id="payday2" value={this.props.nextpay} onChange={this.handleMonthlyNextChange} onBlur={this.handleMonthlyNextBlur} tabIndex="6" />

//<input type="text" className="form-control" name="semi" id="semi" value={this.props.lastpay} onChange={this.handleSemiMonthlyChange} onBlur={this.handleSemiMonthlyBlur} tabIndex="5" />

const mapStateToProps = (state) => ({
    payfrequency: state.FormReducer.payfrequency,
    payday: state.FormReducer.payday,
    payday2: state.FormReducer.payday2,
    lastpay: state.FormReducer.lastpay,
    nextpay: state.FormReducer.nextpay,
    weekday: state.FormReducer.weekday,
    week: state.FormReducer.week,
    otherpay: state.FormReducer.otherpay,
    prevpaydate: state.FormReducer.prevpaydate,
    lastpaydate: state.FormReducer.lastpaydate,
    nextpaydate1: state.FormReducer.nextpaydate1,
    nextpaydate2: state.FormReducer.nextpaydate2,
    payamount: state.FormReducer.payamount,
    paymenttype: state.FormReducer.paymenttype,
    paytypefilled: state.FormReducer.paytypefilled,
    paytypeold: state.FormReducer.paytypeold,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step)),
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setFinance: (financestep) => dispatch(setFinance(financestep)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep))
});

export default connect(mapStateToProps, mapDispatchToProps)(PayFrequency)



// WEBPACK FOOTER //
// ./src/components/views/PaymentSchedule/index.js